import { render, staticRenderFns } from "./MessageAlert.vue?vue&type=template&id=2f38fc4a&scoped=true&"
import script from "./MessageAlert.vue?vue&type=script&lang=js&"
export * from "./MessageAlert.vue?vue&type=script&lang=js&"
import style0 from "./MessageAlert.vue?vue&type=style&index=0&id=2f38fc4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f38fc4a",
  null
  
)

export default component.exports